function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.476 8.691a1 1 0 0 1 .95-.691h1.168a1 1 0 0 1 .951.691l1.4 4.305h4.524a1 1 0 0 1 .951.69l.362 1.111a1 1 0 0 1-.363 1.119l-3.662 2.66 1.4 4.307a1 1 0 0 1-.366 1.12l-.945.684a1 1 0 0 1-1.174-.002l-3.662-2.66-3.668 2.666a1 1 0 0 1-1.177-.001l-.94-.686a1 1 0 0 1-.362-1.117l1.4-4.31-3.662-2.662a1 1 0 0 1-.363-1.12l.363-1.11a1 1 0 0 1 .95-.689h4.526l1.399-4.305zM16.594 9h-1.167l-1.399 4.305a1 1 0 0 1-.951.691H8.55l-.362 1.11 3.663 2.661a1 1 0 0 1 .363 1.118l-1.4 4.311.939.686 3.669-2.666a1 1 0 0 1 1.175 0l3.662 2.66.946-.684-1.4-4.307a1 1 0 0 1 .363-1.118l3.662-2.66-.362-1.11h-4.525a1 1 0 0 1-.95-.692L16.593 9z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dbc4bab92c0bddcece3f39426d1d80cf.svg";
export { ForwardRef as ReactComponent };